<template>
  <div class="animated fadeIn col-md-12">
    <InterviewRowOther :data="other" />
    <Search
      ref="interviewLocationPerson"
      :url="url"
      :allowFields="$lang.searchInterviewLocationPerson_master"
      :hiddenFields="hiddenFields"
      :title="$lang.interviewProfessor"
      :remove_item="remove_item"
      :toggleable="true"
      addModalSize="lg"
      removeModalSize="xl"
      :dynamicButtons="availebelButtons"
      :defaultViewCount="50"
      @getOther="getOther"
      @getPermisson="getPermissions"
      :visibleAdd="isAdmin(permissions, ['admin'])"
    >
      <template slot="addModal" slot-scope="search">
        <AddInterviewLocationPerson
          @closeModal="search.close"
          @refreshData="getItems"
        />
      </template>
    </Search>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="view_add"
      size="xl"
      ok-only
      hide-footer
      hide-header
    >
      <EditInterviewLocationPerson
        :item="item"
        @closeModal="closeModal"
        @refreshData="getItems"
      />
    </b-modal>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AddInterviewLocationPerson from "./addInterviewLocationPerson";
import EditInterviewLocationPerson from "./editInterviewLocationPerson";
import InterviewRowOther from "@/components/base/interviewRowOther";
import { pathOr } from "ramda";
import { isAdmin, generateApiUrl } from "@/shared/utils";

export default {
  name: "search-interview-location-person",
  inject: ["interviewLocationPersonRepository"],
  components: {
    Search,
    AddInterviewLocationPerson,
    EditInterviewLocationPerson,
    InterviewRowOther,
  },
  data() {
    return {
      item: null,
      id: this.$route.params.id,
      hiddenFields: ["created_at.jalali", "created_by"],
      view_add: false,
      other: {},
      buttons: [
        {
          id: "0",
          name: "edit",
          click: this.modalEdit,
          status: null,
        },
        {
          id: "3",
          name: "delete",
          status: [1],
        },
      ],
      permissions: [],
    };
  },
  computed: {
    url() {
      return generateApiUrl(
        ["interview", "interviewLocationPersonMaster"],
        [this.id]
      );
    },
  },
  methods: {
    pathOr,
    isAdmin,
    generateApiUrl,
    getOther(item) {
      this.other = item;
    },
    availebelButtons(item) {
      const id = pathOr(null, ["interview_complete", "id"], item);
      return this.buttons.filter((button) => button.status !== id);
    },
    closeModal() {
      this.view_add = false;
    },
    getItems() {
      this.$refs.interviewLocationPerson.getItems();
    },
    modalEdit(item) {
      this.item = item;
      this.view_add = true;
    },
    async remove_item(item) {
      try {
        const response = await this.interviewLocationPersonRepository.delete(
          item.id
        );
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      }
    },
    getPermissions(permissions) {
      this.permissions = permissions;
    },
  },
};
</script>
